/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_SaveInputs */

const en_us2_profile_editors_save = /** @type {(inputs: Profile_Editors_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save`)
};

const pt_br2_profile_editors_save = /** @type {(inputs: Profile_Editors_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvar`)
};

const es_419_profile_editors_save = /** @type {(inputs: Profile_Editors_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar`)
};

const pt_pt2_profile_editors_save = /** @type {(inputs: Profile_Editors_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar`)
};

const fr_fr2_profile_editors_save = /** @type {(inputs: Profile_Editors_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer`)
};

const de_de2_profile_editors_save = /** @type {(inputs: Profile_Editors_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speichern`)
};

const it_it2_profile_editors_save = /** @type {(inputs: Profile_Editors_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salva`)
};

/**
* | output |
* | --- |
* | "Save" |
*
* @param {Profile_Editors_SaveInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_save = /** @type {((inputs?: Profile_Editors_SaveInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_SaveInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_save(inputs)
	if (locale === "es-419") return es_419_profile_editors_save(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_save(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_save(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_save(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_save(inputs)
	return en_us2_profile_editors_save(inputs)
});
export { profile_editors_save as "profile-editors.save" }